import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import {
  Divider,
  Icon,
  Segment,
  Grid,
  Image,
  Table,
  Label,
  Popup,
  Statistic,
  Loader,
} from 'semantic-ui-react';

import FollowersBarChart from 'dyzio-shared-components/lib/components/followers-bar-chart';

import {
  commaFormatted,
  ierFormat2DP,
  countFormat,
} from '../../utils/helpers/formatting';

const loadingStyle = {
  minHeight: 90,
  marginTop: 30,
};

const textCenterStyle = {
  textAlign: 'center',
  width: '100%',
};

class TwitterProfileDataLarge extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      profile: {},
    };
    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_GET_TWITTER_URL,
      timeout: 5000,
    });

    axiosRetry(this.restClient, {
      delay: 100,
      retries: 3,
    });
  }

  async componentWillMount() {
    const {
      influencer,
    } = this.props;
    const {
      profile,
    } = this.state;
    const handle = _.get(influencer, 'twitter');
    console.log('handle', handle);
    if (handle && _.isEqual(profile, {})) {
      await this.loadTwitterProfile(handle);
    }
  }

  loadTwitterProfile = async handle => {
    const { data } = await this.restClient.get(`/profile/${handle}`);
    console.log('data', data);
    this.setState({
      profile: data,
      loading: false,
    });
  };

  render() {
    const {
      influencer,
      countHistory,
    } = this.props;
    const {
      profile,
      loading,
    } = this.state;
    const {
      user,
      avgLikesPerPost,
      avgRetweetsPerPost,
      avgEngPerPost,
      postsPerWeek,
      postsPerMonth,
      engagementRate,
    } = profile;

    console.log('twitter profile', profile);

    const { verified, profile_image_url } = user || {};
    const handle = _.get(influencer, 'twitter');
    let twitterData = _.filter(countHistory, item => _.has(item, 'twitterCount'));
    if (_.isEmpty(twitterData)) {
      twitterData = [{
        twitterCount: _.get(profile, 'user.followers_count'),
        createdDate: moment().format('MMM D'),
      }];
    }
    console.log('twitterData', twitterData);
    const graphProps = {
      label: 'followers',
      labels: _.map(twitterData, item => moment(item.createdDate).format('MMM D')),
      values: _.map(twitterData, 'twitterCount'),
      rgbColorCode: '#55acee',
    };
    const lastTwitterScan = _.last(twitterData);
    return (
      <Segment color="blue">
        {
          loading &&
          <Loader
            active
            inline="centered"
            content="Loading Twitter data"
            style={loadingStyle}
          />
        }
        {!loading && <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <h3>
                <Icon name="twitter" color="blue" />
                Twitter
              </h3>
              <Divider />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row divided>
            <Grid.Column width={4}>
              <Image
                src={profile_image_url}
                shape="circular"
                centered
                size="small"
              />
              <Table basic="very" fluid textAlign="center">
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      { handle }
                      { verified && <Icon name="check circle" color="blue" /> }
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>{commaFormatted(lastTwitterScan.twitterCount)} followers</Table.Cell>
                  </Table.Row>
                  {
                    !verified &&
                    <Table.Row>
                      <Table.Cell>
                        <Popup
                          trigger={<Label basic color="grey" content="not verified" />}
                          content={`${handle} is not verified by Twitter (blue tick)`}
                        />
                      </Table.Cell>
                    </Table.Row>
                  }
                </Table.Body>
              </Table>
            </Grid.Column>
            <Grid.Column width={7}>
              <FollowersBarChart {...graphProps} />
            </Grid.Column>
            <Grid.Column width={5}>

              { loading && <Loader active content="Loading..." /> }
              { user && engagementRate && !loading &&
                <div>
                  <Statistic style={textCenterStyle}>
                    <Statistic.Value>{ierFormat2DP(engagementRate)}%</Statistic.Value>
                    <Statistic.Label>engagement rate</Statistic.Label>
                  </Statistic>
                  <Table basic="very" fluid compact>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>avg. likes per post</Table.Cell>
                        <Table.Cell>{countFormat(avgLikesPerPost)}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>avg. retweets per post</Table.Cell>
                        <Table.Cell>{countFormat(avgRetweetsPerPost)}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>avg. engagements per post</Table.Cell>
                        <Table.Cell>{countFormat(avgEngPerPost)}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>posts per week</Table.Cell>
                        <Table.Cell>{countFormat(postsPerWeek)}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>posts per month</Table.Cell>
                        <Table.Cell>{countFormat(postsPerMonth)}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </div>
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>}
      </Segment>
    );
  }
}

TwitterProfileDataLarge.propTypes = {
  influencer: PropTypes.object.isRequired,
  countHistory: PropTypes.array,
};

TwitterProfileDataLarge.defaultProps = {
  countHistory: [],
};

export default TwitterProfileDataLarge;



/** WEBPACK FOOTER **
 ** ./src/components/twitter-profile-data-large/index.js
 **/